import dd from 'DD'
import { shareDD, shareDD2, isPc } from '../utils/utils'
import Suspension from '../components/suspension'
import { post } from '../utils/request'
import { Toast } from 'vant'
export default {
  components: {
    Suspension
  },
  data () {
    return {
      platform: dd.env.platform
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setRight({
          show: false, // 控制按钮显示， true 显示， false 隐藏， 默认true
          control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
          text: '分享', // 控制显示文本，空字符串表示显示默认文本
          onSuccess: (result) => {
            vm.getShareContent()
          }
        })
      }
    })
  },
  mounted () {
    // const _this = this
    // dd.device.base.getPhoneInfo({
    //   onSuccess: function (data) {
    //     // alert('现在是手机移动端')
    //     _this.isPc = false
    //   },
    //   onFail: function (err) {
    //     alert(JSON.stringify(err))
    //   }
    // })
  },
  methods: {
    async getShareContent (callback) {
      const url = `dingtalk://dingtalkclient/action/openapp?corpid=ding7a05491d2e914134&container_type=work_platform&app_id=0_941215726&redirect_type=jump&redirect_url=https://ui-circle.fosun.com${this.$route.fullPath}`
      const matched = this.$route.matched
      const path = matched[matched.length - 1].path
      const { data: { detail: { title, content, image } } } = await post({
        url: '/share/getShare',
        data: {
          url: path
        }
      })
      const propsTtitle = title.indexOf('this') !== -1 ? title.substring(title.indexOf('.') + 1) : ''
      const props = content.indexOf('this') !== -1 ? content.substring(content.indexOf('.') + 1) : ''
      let str = props ? this[props] : content
      const regex = /<br\/>/g
      str = str.replace(regex, '\n')
      if (await isPc()) {
        const txa = document.createElement('textarea')
        txa.value = url
        document.body.appendChild(txa)
        txa.select()
        document.execCommand('Copy')
        document.body.removeChild(txa)
        Toast.success('链接已复制到剪贴板')
      }
      shareDD2({
        title: propsTtitle ? this[propsTtitle] : title,
        img: image,
        content: str,
        url
      })
    },
    shareDD () {
      shareDD({
        title: '星言星语，你的一站式复星生活社区！ ',
        content: '星内热点话题，谁又在说星言星语？快来前排围观同学的大胆开麦！',
        url: '/exerland/makeComplaints'
      })
    }
  }
}
